module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recovery-grade-status-card"
  }, [_c('div', {
    staticClass: "recovery-grade-status"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h4', [_vm._v(_vm._s(_vm.legend))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("Move to top")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grades"
  }, [_c('div', {
    staticClass: "grade-status-icon grade-color-a"
  }, [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "grade-status-icon grade-color-b"
  }, [_vm._v("B")]), _vm._v(" "), _c('div', {
    staticClass: "grade-status-icon grade-color-c"
  }, [_vm._v("C")]), _vm._v(" "), _c('div', {
    staticClass: "grade-status-icon grade-color-d"
  }, [_vm._v("D")]), _vm._v(" "), _c('div', {
    staticClass: "grade-status-icon grade-color-e"
  }, [_vm._v("E")]), _vm._v(" "), _c('div', {
    staticClass: "grade-status-icon grade-color-f"
  }, [_vm._v("F")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dab4fb6a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/RecoveryGradeStatus.vue
// module id = 863
// module chunks = 0